// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1sXYP","col":"styles_col__2Bql2"};